/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightPointsMatchedOffer } from './FlightPointsMatchedOffer';
import {
    FlightPointsMatchedOfferFromJSON,
    FlightPointsMatchedOfferFromJSONTyped,
    FlightPointsMatchedOfferToJSON,
    FlightPointsMatchedOfferToJSONTyped,
} from './FlightPointsMatchedOffer';
import type { FlightPointsOnlyOffer } from './FlightPointsOnlyOffer';
import {
    FlightPointsOnlyOfferFromJSON,
    FlightPointsOnlyOfferFromJSONTyped,
    FlightPointsOnlyOfferToJSON,
    FlightPointsOnlyOfferToJSONTyped,
} from './FlightPointsOnlyOffer';

/**
 * One loyalty program's outcome for a search.
 * @export
 * @interface FlightPointsSourceResult
 */
export interface FlightPointsSourceResult {
    /**
     * 
     * @type {string}
     * @memberof FlightPointsSourceResult
     */
    source: string;
    /**
     * "completed": award inventory found. "no_results": the scrape finished and this route has no award availability. "failed": the scrape errored. "timeout": no answer yet — the scrape is still running or still queued. Only "no_results" means "there is nothing"; "timeout" means "ask again".
     * @type {string}
     * @memberof FlightPointsSourceResult
     */
    status: FlightPointsSourceResultStatusEnum;
    /**
     * Cash itineraries from the original search that this program prices in miles.
     * @type {Array<FlightPointsMatchedOffer>}
     * @memberof FlightPointsSourceResult
     */
    matched?: Array<FlightPointsMatchedOffer>;
    /**
     * Award inventory with no cash analogue in the original search — itineraries the award scrape surfaced that Google Flights did not return.
     * @type {Array<FlightPointsOnlyOffer>}
     * @memberof FlightPointsSourceResult
     */
    pointsOnly?: Array<FlightPointsOnlyOffer>;
}


/**
 * @export
 */
export const FlightPointsSourceResultStatusEnum = {
    Completed: 'completed',
    NoResults: 'no_results',
    Failed: 'failed',
    Timeout: 'timeout'
} as const;
export type FlightPointsSourceResultStatusEnum = typeof FlightPointsSourceResultStatusEnum[keyof typeof FlightPointsSourceResultStatusEnum];


/**
 * Check if a given object implements the FlightPointsSourceResult interface.
 */
export function instanceOfFlightPointsSourceResult(value: object): value is FlightPointsSourceResult {
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function FlightPointsSourceResultFromJSON(json: any): FlightPointsSourceResult {
    return FlightPointsSourceResultFromJSONTyped(json, false);
}

export function FlightPointsSourceResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPointsSourceResult {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'],
        'status': json['status'],
        'matched': json['matched'] == null ? undefined : ((json['matched'] as Array<any>).map(FlightPointsMatchedOfferFromJSON)),
        'pointsOnly': json['points_only'] == null ? undefined : ((json['points_only'] as Array<any>).map(FlightPointsOnlyOfferFromJSON)),
    };
}

export function FlightPointsSourceResultToJSON(json: any): FlightPointsSourceResult {
    return FlightPointsSourceResultToJSONTyped(json, false);
}

export function FlightPointsSourceResultToJSONTyped(value?: FlightPointsSourceResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'status': value['status'],
        'matched': value['matched'] == null ? undefined : ((value['matched'] as Array<any>).map(FlightPointsMatchedOfferToJSON)),
        'points_only': value['pointsOnly'] == null ? undefined : ((value['pointsOnly'] as Array<any>).map(FlightPointsOnlyOfferToJSON)),
    };
}

